// Landing UX Rocks: tras enviar la inscripción, el panel de agradecimiento
// sustituye al formulario (Figma `4:32298`, «Success · solicitud recibida»).
//
// Se escucha `wpcf7mailsent` acotado a la tarjeta de la landing, para no
// interferir con ningún otro formulario de la página.

const TARJETA = '[data-rocks-inscripcion]';

document.addEventListener(
    'wpcf7mailsent',
    (evento) => {
        const formulario = evento.target;
        if (!(formulario instanceof Element)) return;

        const tarjeta = formulario.closest(TARJETA);
        const gracias = tarjeta ? tarjeta.querySelector('[data-rocks-gracias]') : null;
        if (!tarjeta || !gracias) return;

        const propioFormulario = tarjeta.querySelector('[data-rocks-formulario]');
        if (propioFormulario) propioFormulario.setAttribute('hidden', '');
        gracias.removeAttribute('hidden');

        const titulo = gracias.querySelector('h2');
        if (titulo) titulo.focus();
    },
    false
);
